// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"d1941060","422":"23b90915","431":"aa5fdb4a","562":"8a33e200","706":"e0d554b5","809":"3dac76a6","839":"e14112c0"}[chunkId] + ".chunk.js";
};